import { useConfigurationServicePostCustomApiConfigurationMail } from "../../openapi/api/queries";
import { RequestQuoteForm } from "../RequestQuoteForm/RequestQuoteForm";

import { JSX } from "react";
import { useTranslation } from "react-i18next";

import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  CircularProgress,
  Dialog,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { useCsConfiguration } from "@plansoft-configuration-renderer/framework";

import { RequestQuoteSuccess } from "./RequestQuoteSuccess";
import { mockRequestQuoteValues } from "./mock";

export function RequestQuoteDialog({
  handleClose,
  sessionId,
}: {
  handleClose: () => void;
  sessionId: string;
}): JSX.Element {
  const { t, i18n } = useTranslation();
  const {
    mutate: sendRequest,
    isSuccess,
    isError,
    isPending,
  } = useConfigurationServicePostCustomApiConfigurationMail({
    onSuccess: () => {},
    onError: (error) => {
      console.error("Error sending request:", error);
    },
  });

  const context = useCsConfiguration().context;
  const fhIdent = context?.FH_IDENT;

  return (
    <Dialog
      onClose={handleClose}
      open={true}
      maxWidth="xl"
      slotProps={{
        paper: {
          sx: {
            width: "944px",
          },
        },
      }}
    >
      <DialogTitle>
        <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
          {!isSuccess
            ? t("AS:dialog.requestQuote.title.requestQuote")
            : t("AS:dialog.requestQuote.title.success")}
        </Typography>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      {isPending && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            bgcolor: "rgba(255,255,255,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1,
          }}
          aria-busy
          aria-live="polite"
        >
          <CircularProgress />
        </Box>
      )}

      {isSuccess ? <RequestQuoteSuccess onClose={handleClose} /> : null}
      {!isError && !isSuccess ? (
        <RequestQuoteForm
          onSubmit={(values) =>
            sendRequest({
              requestBody: {
                userSessionId: sessionId,
                title: values.salutation,
                firstName: values.firstName,
                lastName: values.lastName,
                userEmailAdress: values.email,
                phoneNumber: values.phone,
                companyName: values.company,
                street: values.street,
                nr: values.number,
                zipCode: values.postalCode,
                city: values.city,
                country: values.country,
                fhIdent: fhIdent,
                fhAnrede: values.specialistRetailer?.salutation,
                fhFirma: values.specialistRetailer?.company,
                fhVorname: values.specialistRetailer?.firstName,
                fhName: values.specialistRetailer?.lastName,
                fhMail: values.specialistRetailer?.email,
                fhOrt: values.specialistRetailer?.city,
                callbackMorning: values.contactHours.morning,
                callbackAfternoon: values.contactHours.afternoon,
                message: values.comment,
                localeId: i18n.language,
              },
            })
          }
          defaultValues={window.debugMode ? mockRequestQuoteValues : undefined}
        />
      ) : null}
      {isError && (
        <Typography color="error" sx={{ padding: 2 }}>
          {t("AS:dialog.requestQuote.error.message")}
        </Typography>
      )}
    </Dialog>
  );
}
